import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
import axios from 'axios';
function __rest(s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
var fetchHealthContent = function fetchHealthContent(_ref) {
  var config = _ref.config,
    uri = _ref.uri,
    reporter = _ref.reporter;
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var healthBaseUrl, logger, response, _response$data$result, _response$data$result2, _response$data$result3, body, _id, validityStart, validityEnd, contentType;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            healthBaseUrl = config.healthBaseUrl;
            logger = reporter !== null && reporter !== void 0 ? reporter : console;
            _context.prev = 2;
            _context.next = 5;
            return axios.get("/r/document/".concat(uri), {
              baseURL: healthBaseUrl,
              params: {
                bodyContentType: 'html'
              }
            });
          case 5:
            response = _context.sent;
            _response$data$result = response.data.result, _response$data$result2 = _response$data$result.publishedPeriod, _response$data$result3 = _response$data$result2.latestRevision, body = _response$data$result3.body, _id = _response$data$result3._id, validityStart = _response$data$result2.validityStart, validityEnd = _response$data$result2.validityEnd, contentType = _response$data$result.contentType;
            return _context.abrupt("return", {
              body: body,
              validFrom: validityStart,
              validTo: validityEnd,
              versionId: _id,
              documentType: contentType
            });
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](2);
            logger.error('Error on fetch health content', _context.t0);
            return _context.abrupt("return", null);
          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 10]]);
  }));
};
var getLocaleFromUri = function getLocaleFromUri(uri) {
  var uriParts = uri.split('/').filter(function (uriPart) {
    return uriPart.trim() !== '';
  });
  var localePart = uriParts[1];
  return localePart !== null && localePart !== void 0 ? localePart : null;
};
var maxRetries = 5;
var ECONNRESET_ERROR_CODE = 'ECONNRESET';
var fetchOtContent = function fetchOtContent(_ref2) {
  var config = _ref2.config,
    uri = _ref2.uri,
    reporter = _ref2.reporter,
    locale = _ref2.locale;
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var otBaseUrl, logger, localeFromUri, preparedUri, preparedLocale, retries, response, _response$data$result4, contentType, _response$data$result5, _id, body;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            otBaseUrl = config.otBaseUrl;
            logger = reporter !== null && reporter !== void 0 ? reporter : console;
            localeFromUri = getLocaleFromUri(uri);
            preparedUri = localeFromUri ? uri.replace(localeFromUri, '').slice(0, -1) : uri;
            preparedLocale = localeFromUri !== null && localeFromUri !== void 0 ? localeFromUri : locale;
            if (preparedLocale) {
              _context2.next = 8;
              break;
            }
            logger.error('Locale for URI is missing. Cannot fetch One Trust content.');
            return _context2.abrupt("return", null);
          case 8:
            retries = 0;
          case 9:
            if (!(retries < maxRetries)) {
              _context2.next = 29;
              break;
            }
            _context2.prev = 10;
            _context2.next = 13;
            return axios.get("/document/".concat(preparedUri, "/").concat(preparedLocale), {
              baseURL: otBaseUrl
            });
          case 13:
            response = _context2.sent;
            _response$data$result4 = response.data.result, contentType = _response$data$result4.contentType, _response$data$result5 = _response$data$result4.publishedPeriod.latestRevision, _id = _response$data$result5._id, body = _response$data$result5.body;
            return _context2.abrupt("return", {
              body: body,
              versionId: _id,
              documentType: contentType
            });
          case 18:
            _context2.prev = 18;
            _context2.t0 = _context2["catch"](10);
            if (!(_context2.t0.code === ECONNRESET_ERROR_CODE)) {
              _context2.next = 25;
              break;
            }
            logger.info('Connection with OneTrust LDS Proxy reset, retrying...');
            retries += 1;
            _context2.next = 27;
            break;
          case 25:
            logger.error('Error on fetch One Trust content', _context2.t0);
            return _context2.abrupt("return", null);
          case 27:
            _context2.next = 9;
            break;
          case 29:
            logger.error("Failed to establish connection with OneTrust LDS Proxy after ".concat(maxRetries, " retries."));
            return _context2.abrupt("return", null);
          case 31:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[10, 18]]);
  }));
};
var LdsContentFetchers = {
  health: function health(_a) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var args;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              args = __rest(_a, []);
              return _context3.abrupt("return", fetchHealthContent(Object.assign({}, args)));
            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
  },
  ot: function ot(_b) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var args;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              args = __rest(_b, []);
              return _context4.abrupt("return", fetchOtContent(Object.assign({}, args)));
            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
  }
};
var Platform;
(function (Platform) {
  Platform["Health"] = "health";
  Platform["HyHo"] = "hyho";
  Platform["OneTrust"] = "ot";
})(Platform || (Platform = {}));
export { LdsContentFetchers, Platform };